enum ActionType {
    REQUEST_ETS = '[DASHBOARD/ETS_VALUE] GET VALUE',
    RECEIVE_ETS = '[DASHBOARD/ETS_VALUE] SET VALUE',
    ETS_REQUEST_FAILED = '[DASHBOARD/ETS_VALUE] REQUEST FAILED',
}

export default ActionType
